import { Course } from '@/domain/entities/problem/course'
import { ProblemRepository } from '@/domain/repositories/problem/ProblemRepository'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'

export class GetCourseUseCase {
  constructor(private repository: ProblemRepository) {}

  async getCourseList(displayLanguage: DisplayLanguageType): Promise<Course[]> {
    try {
      const data = await this.repository.getCourseList(displayLanguage)
      return data
    } catch (error) {
      console.error(`Error in GetCourseUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }

  async getCourseById(displayLanguage: DisplayLanguageType, courseId: number): Promise<Course> {
    try {
      const data = await this.repository.getCourseById(displayLanguage, courseId)
      return data
    } catch (error) {
      console.error(`Error in GetCourseUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
